import React from "react"
import { FacebookProvider, Like } from 'react-facebook';
import { Share } from 'react-twitter-widgets'
import Popup from 'reactjs-popup';
import { Button } from "react-bootstrap"
import { BsFillShareFill} from "react-icons/bs"


const SocialMedia = ({ uri, position }) => {

  return (
    <>
      <div className="d-flex flex-column ilir-social-media-buttons flex-shrink-1 justify-content-right">
      <Popup trigger={<Button variant="outline-primary" className="action-button">Share <BsFillShareFill /></Button>} position={position}>
        <div id="ilir-social-media-buttons-popup" className="p-2">
        <div className="ilir-fb-button">
          <FacebookProvider appId="2245187545800410">
          <Like href={uri} colorScheme="dark" layout="button" size="large" share />
          </FacebookProvider>
        </div>
        <div className="d-flex me-1 mt-1 ilir-twitter-button">
        <Share url={uri} options={{ size: "large" }} />
        </div>
        </div>
      </Popup>
        
      </div>
    </>
  )
}


export default SocialMedia
